import { FunctionComponent, useEffect } from 'react';
import { baseEventData as __baseEventData, baseEventDataType, LoginMethodsEnum, LoginMethodsType } from './constants';
import { trackEvent } from '../../utils/event-tracking/track-event';
import { getHashedCustomerEmail, getHashedCustomerId } from '../../utils/event-tracking/event-data';

export const trackLoginComplete = ({
  baseEventData = __baseEventData.default,
  loginMethod = 'email',
  isCreate = false,
}: {
  baseEventData?: baseEventDataType;
  loginMethod?: LoginMethodsType;
  isCreate?: boolean;
}) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.form.complete',
    group: isCreate ? 'create an account' : 'login',
    eventLabel: loginMethod,
    data: {
      customerId: getHashedCustomerId(),
      customerEmail: getHashedCustomerEmail(),
    },
  });
};

export const trackLoginStart = ({
  baseEventData = __baseEventData.default,
  loginMethod = 'email',
  isCreate,
}: {
  baseEventData?: baseEventDataType;
  loginMethod?: LoginMethodsType;
  isCreate?: boolean;
}) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.account.interactions.click',
    group: `${isCreate === undefined ? 'login or create' : isCreate ? 'create an account' : 'login'}`,
    eventLabel: loginMethod === 'email' ? 'my account' : loginMethod,
  });
};

export const trackLogout = ({ baseEventData = __baseEventData.default }: { baseEventData?: baseEventDataType }) => {
  trackEvent({
    ...baseEventData,
    event: 'custom.account.interactions.click',
    group: `logout`,
    data: {
      customerId: getHashedCustomerId(),
      customerEmail: getHashedCustomerEmail(),
    },
  });
};

export const useLoginTracking = ({
  baseEventData = __baseEventData.default,
}: {
  baseEventData?: baseEventDataType;
}): FunctionComponent => {
  useEffect(() => {
    const queryParams = new URL(window.location.href).searchParams;

    if (queryParams.has('loginMethod')) {
      trackLoginComplete({
        baseEventData,
        loginMethod: LoginMethodsEnum[(queryParams.get('loginMethod') ?? 'email').toLowerCase()],
        isCreate: queryParams.has('newUser'),
      });
      setTimeout(() =>
        // Give useLoginPage and other pages a chance to get this value
        window.history.pushState(
          {},
          document.title,
          window.location.href.replace(/[?&]((loginMethod=)|(newUser=))[\w.-]+/g, '')
        )
      );
    }
  }, []);

  return null;
};
